import { takeEvery, takeLatest, delay } from 'redux-saga'
import { put, select, fork, take, call, cancel, cancelled } from 'redux-saga/effects'
import actionTypes from '../actions/actionTypes'
import { storefrontSync, fetchShareDataSync } from 'sync'
import callAny from 'redux/sagas/helpers/call_any'
import { storefrontSelectors } from 'redux/selectors'
import loginActions from 'redux/actions/loginActions'
import config from 'config'

function *initializeStorefrontAdmin() {
	try {
		const response = yield callAny(storefrontSync.getStorefrontOwnerData)
		yield put({
			type: actionTypes.STOREFRONT_OWNER_DATA_FETCHED,
			data: response.payload,
		})
	} catch (error) {
		//console.log(error)
		yield put({
			type: actionTypes.STOREFRONT_OWNER_INITIALIZE_ERROR,
			redirectUrl: config.app + 'library',
		})
	}
}

function *queryOwnerLessons(limit, page, full_page) {
	const response = yield callAny(storefrontSync.getStorefrontLessons, limit, page)
	yield put({
		type: actionTypes.STOREFRONT_OWNER_LESSONS_FETCHED,
		entities: response.payload.entities,
		more: response.payload.more,
		full_page,
		count: response.payload.count,
	})
}

function *ownerLessonsLoadNextPage() {
	while (true) {
		yield take([
			actionTypes.STOREFRONT_OWNER_LOAD_NEXT_PAGE,
			actionTypes.STOREFRONT_OWNER_INITIALIZE,
			actionTypes.STOREFRONT_LESSONS_PICKER_ADD_SUCCESS,
		])
		try {
			const lessonParams = yield select(storefrontSelectors.storefrontOwnerLessonsListQuery)
			yield call(queryOwnerLessons, null, lessonParams.page + 1, true )
			//This delay is to prevent two calls from redux infinite scroll since npps take some time to get to their actual size.
			yield call(delay, 250)
		} catch (error) {
			yield put({
				type: actionTypes.STOREFRONT_OWNER_DATA_ERROR,
			})
		}

	}
}

function *doSearchLessons(searchParams) {
	try {
		if (searchParams.more) {
			const response = yield callAny(storefrontSync.searchStorefrontLessons, searchParams.page, searchParams.order_field, searchParams.order_type, searchParams.search)
			yield put({
				type: actionTypes.STOREFRONT_FOUND_LESSONS,
				entities: response.payload.entities, //TODO: entities duplicated because of how the action is handled in lessonsPickerReducer and lessonsreducers
				payload: {
					entities: response.payload.entities,
					page: response.payload.page,
					more: response.payload.more,
				},
			})
		}
	} finally {
		if (yield cancelled()) {
		}
	}

}

function *lessonsPickerSearchLessons() {
	let currentSearchParams, currentRequest
	while (true) {
		const action = yield take([actionTypes.STOREFRONT_LESSONS_PICKER_SEARCH_LESSONS, actionTypes.STOREFRONT_LESSONS_PICKER_INITIALIZE, actionTypes.STOREFRONT_FOUND_LESSONS])
		if (action.type === actionTypes.STOREFRONT_FOUND_LESSONS) {
			currentSearchParams = null
			currentRequest = null
		} else {
			try {
				const searchParams = yield select(storefrontSelectors.lessonsPickerModal)
				if (currentSearchParams && currentSearchParams.order_field === searchParams.order_field && currentSearchParams.order_type === searchParams.order_type && currentSearchParams.search === searchParams.search) {
				} else {
					currentSearchParams = searchParams
					if (currentRequest) {
						yield cancel(currentRequest)
					}
					currentRequest = yield fork(doSearchLessons, searchParams)
				}
			} catch (error) {
				// console.log(error)
			}
		}
	}

}

function *lessonsPickerSaveLessons() {
	try {
		const searchParams = yield select(storefrontSelectors.lessonsPickerModalSave)
		yield callAny(storefrontSync.saveLessons, searchParams.lessonsIDs)
		yield put({
			type: actionTypes.STOREFRONT_LESSONS_PICKER_ADD_SUCCESS,
		})
	} catch (error) {
		// console.log(error)
	}
}

function *removeLesson(action) {
	try {
		yield put({
			type: actionTypes.STOREFRONT_REMOVE_LESSON_CONFIRM,
			entityUID: action.entityUID,
		})
		const confirmAction = yield take([actionTypes.STOREFRONT_REMOVE_LESSON_CONFIRMED, actionTypes.STOREFRONT_REMOVE_LESSON_CANCELLED])
		if (confirmAction.type === actionTypes.STOREFRONT_REMOVE_LESSON_CONFIRMED) {
			yield callAny(storefrontSync.removeLesson, action.entityID)
			yield put({
				type: actionTypes.STOREFRONT_REMOVE_LESSON_SUCCESS,
				entityUID: action.entityUID,
				entityID: action.entityID,
			})
			const visibleLessons = yield select(storefrontSelectors.ownerViewSelector)
			yield call(queryOwnerLessons, 1, visibleLessons.lessons.length, false )
		}
	} catch (error) {
		// console.log(error)
	}
}

function *initializeStorefrontVisitor(action) {
	try {
		const response = yield callAny(storefrontSync.getStorefrontVisitorData, action.ownerId)
		yield put({
			type: actionTypes.STOREFRONT_VISITOR_DATA_FETCHED,
			data: response.payload,
			ownerId: action.ownerId,
		})
	} catch (error) {
		yield put({
			type: actionTypes.STOREFRONT_VISITOR_INITIALIZE_ERROR,
			redirectUrl: '/not_found',
		})
	}
}

function *followOwner(action) {
	try {
		const response = yield callAny(storefrontSync.followOwner, action.ownerUID)
		yield put({
			type: actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER_SUCCESS,
			data: response.payload,
			message: response.message,
		})
	} catch (error) {
		yield put({
			type: actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER_ERROR,
		})
	}
}

function *unFollowOwner(action) {
	try {
		const response = yield callAny(storefrontSync.unFollowOwner, action.ownerUID)
		yield put({
			type: actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER_SUCCESS,
			data: response.payload,
			message: response.message,
		})
	} catch (error) {
		yield put({
			type: actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER_ERROR,
		})
	}
}

function *queryVisitorLessons(ownerId, limit, page, full_page) {
	const response = yield callAny(storefrontSync.getStorefrontVisitorLessons, ownerId, limit, page)
	yield put({
		type: actionTypes.STOREFRONT_VISITOR_LESSONS_FETCHED,
		entities: response.payload.entities,
		more: response.payload.more,
		full_page,
		count: response.payload.count,
	})
}

function *visitorLessonsLoadNextPage() {
	while (true) {
		yield take([actionTypes.STOREFRONT_VISITOR_INITIALIZE, actionTypes.STOREFRONT_VISITOR_LOAD_NEXT_PAGE])
		try {
			const lessonParams = yield select(storefrontSelectors.storefrontVisitorLessonsListQuery)
			yield call(queryVisitorLessons, lessonParams.ownerId, null, lessonParams.page + 1, true)
			yield call(delay, 250)
		} catch (error) {
			yield put({
				type: actionTypes.STOREFRONT_VISITOR_DATA_ERROR,
			})
		}

	}
}

function *lessonsSort() {
	try {
		const sortLessonsList = yield select(storefrontSelectors.storefrontOwnerSort)
		if (sortLessonsList.length) {
			yield callAny(storefrontSync.sortLessons, sortLessonsList)
		}
	} catch (error) {
		// console.log(error)
	}
}

//THROTTLING BECAUSE DRAG AND DROP FIRES AN UNWANTED HOVER WHEN INITIATED
function *throttleHover() {
	yield call(delay, 150)
	yield put({
		type: actionTypes.STOREFRONT_OWNER_ALLOW_HOVER,
	})
}

function *sendSubmittedBio(action) {
	try {
		yield callAny(storefrontSync.saveBio, action.value)
		yield put({
			type: actionTypes.STOREFRONT_OWNER_BIO_SUCCESS,
		})
	} catch (error) {
		yield put({
			type: actionTypes.STOREFRONT_OWNER_BIO_ERROR,
		})
	}
}

function *processLatestFollowUnfollowActionOneAtTheTime() {
	let previousownerUID = 0
	let previousFork = null
	let pendingAction = null
	let action
	while (true) {
		action = yield take([
			actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER,
			actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER_SUCCESS,
			actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER_ERROR,

			actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER,
			actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER_SUCCESS,
			actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER_ERROR,
		])

		const visitorIsLoggedIn = yield select(storefrontSelectors.storefrontVisitorIsLoggedIn)
		if (!visitorIsLoggedIn) {
			yield put(loginActions.userNotLoggedIn())
		} else {
			if ((action.type !== actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER) && (action.type !== actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER)) {
				if (pendingAction) {
					if (pendingAction.type == actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER)
						previousFork = yield fork(followOwner, pendingAction)
					if (pendingAction.type == actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER)
						previousFork = yield fork(unFollowOwner, pendingAction)
					pendingAction = null
				}
				previousFork = null
			}

			if ((action.type === actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER) || (action.type === actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER)) {
				if ((previousownerUID === action.ownerUID) && (previousFork !== null)) {
					pendingAction = action
				} else {
					previousownerUID = action.ownerUID

					if (action.type == actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER)
						previousFork = yield fork(followOwner, action)
					if (action.type == actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER)
						previousFork = yield fork(unFollowOwner, action)
				}
			}
		}
	}
}

function *getStorefrontLessonShareData(action) {
	try {
		const response = yield callAny(fetchShareDataSync, action.ownerId, 'storefront', null)

		yield put({
			type: actionTypes.SHARE_VIEW_DATA_LOADED,
			payload: response.payload.data,
			entityType: 'storefront',
			entityUID: action.ownerId,
		})
	} catch (error) {
		yield put({
			type: actionTypes.SHARE_VIEW_DATA_FAILED,
		})
	}
}

export default [
	takeEvery(actionTypes.STOREFRONT_OWNER_INITIALIZE, initializeStorefrontAdmin),
	fork(lessonsPickerSearchLessons),
	takeLatest(actionTypes.STOREFRONT_LESSONS_PICKER_SAVE_LESSONS, lessonsPickerSaveLessons),
	fork(ownerLessonsLoadNextPage),
	fork(processLatestFollowUnfollowActionOneAtTheTime),
	takeLatest(actionTypes.STOREFRONT_REMOVE_LESSON, removeLesson),
	takeEvery(actionTypes.STOREFRONT_VISITOR_INITIALIZE, initializeStorefrontVisitor),
	fork(visitorLessonsLoadNextPage),
	takeLatest(actionTypes.STOREFRONT_OWNER_SORT_LESSONS_RELEASE, lessonsSort),
	takeLatest(actionTypes.STOREFRONT_OWNER_SORT_START, throttleHover),
	takeEvery(actionTypes.STOREFRONT_OWNER_SEND_SUBMITTED_BIO, sendSubmittedBio),
	takeLatest(actionTypes.STOREFRONT_SHARE, getStorefrontLessonShareData),
]
